import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as CommunityConsumer } from '../../../../../../../contexts/CommunityContext';
import HoverCallToActionWrapperComponent from '../../../../../../CallToAction/HoverCallToAction/HoverCallToActionWrapperComponent/HoverCallToActionWrapperComponent';
import Tag from '../../../../../../Elements/Tag/Tag';
import TagList from '../TagList/TagList';

import './MatchingTags.scss';

export default class MatchingTags extends React.PureComponent {
    constructor(props) {
        super();
        this.contentHash = `tag-${Math.random().toString(36).substring(2, 15)}`;
    }

    static propTypes = {
        /**
         * matching interest between group and user
         */
        interests: PropTypes.array.isRequired,
        /**
         * search results of groups
         */
        locations: PropTypes.array.isRequired,
    };

    static defaultProps = {
        interests: [],
        locations: [],
    };

    renderTagWithHoverOverlay = (taglist = [], seeMoreText = '', type = '') => (
        <CommunityConsumer>
            {({ setHoverComponent, closeHoverComponent, hoveredComponent }) => (
                <HoverCallToActionWrapperComponent
                    contentHash={`${type}${this.contentHash}`}
                    contextHoverFunction={setHoverComponent}
                    contextCloseHover={closeHoverComponent}
                    contextHoveredComponent={hoveredComponent}
                    hoverComponent={
                        <div className="tag-overlay-wrapper">
                            <div className="match-header">MATCHES</div>
                            <TagList
                                tagNames={taglist.map(
                                    (tagItem) => tagItem.name
                                )}
                                tagClassName={`tag ${type}-tag`}
                            />
                        </div>
                    }
                >
                    <Tag
                        shouldAllowDelete={false}
                        tagCssClass={`tag ${type}-tag`}
                    >
                        {seeMoreText}
                    </Tag>
                </HoverCallToActionWrapperComponent>
            )}
        </CommunityConsumer>
    );

    render() {
        const { interests, locations } = this.props;

        const hasInterest = interests && interests.length;
        const hasLocation = locations && locations.length;

        const seeMoreInterestTagText =
            interests.length > 1 ? `+${interests.length - 1}` : null;
        const seeMoreLocationTagText =
            locations.length > 1 ? `+${locations.length - 1}` : null;

        if (hasInterest || hasLocation) {
            return (
                <div className="component-Groups-Search-SearchPageSection-GroupSearchResults-MatchingTags">
                    <div className="match-header">MATCHES</div>

                    {!!hasInterest && (
                        <TagList
                            tagNames={Array(interests[0].name)}
                            tagClassName="tag interest-tag"
                        >
                            {seeMoreInterestTagText &&
                                this.renderTagWithHoverOverlay(
                                    interests,
                                    seeMoreInterestTagText,
                                    'interest'
                                )}
                        </TagList>
                    )}

                    {!!hasLocation && (
                        <TagList
                            tagNames={Array(locations[0].name)}
                            tagClassName="tag location-tag"
                        >
                            {seeMoreLocationTagText &&
                                this.renderTagWithHoverOverlay(
                                    locations,
                                    seeMoreLocationTagText,
                                    'location'
                                )}
                        </TagList>
                    )}
                </div>
            );
        }

        return null;
    }
}
